import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { TRUE } from '../../utilities/constants';
import { RxdbCollectionName } from '../rxdbCollectionName';
import type { SignAndStampFile, SignAndStampFileCollection } from './signAndStamp.types';

const useBulkSignAndStamp = (inspectionIds: string[]) => {
  const getSignAndStampQuery = useCallback(
    (collection: SignAndStampFileCollection) =>
      collection?.find({
        selector: { inspectionId: { $in: inspectionIds }, isDelete: { $ne: TRUE } },
      }),
    [inspectionIds],
  );

  const { result } = useRxData<SignAndStampFile>(
    RxdbCollectionName.SIGN_AND_STAMP_FILE,
    getSignAndStampQuery,
  );

  const signAndStampDataFromInspections = result.filter(sign => !sign.fkAssetInspectionTask);

  return { signAndStampDataFromInspections };
};

export default useBulkSignAndStamp;
